const { de: common } = require("../../common");

module.exports = {
	...common,
};
